export default __webpack_public_path__ + "static/media/bgus.fecf8392.jpg";